<template>
  <!--    <el-container>-->
  <!--      <el-header>-->
  <!--        <img src="https://file.21dct.com/download/HomeV2/logo_100_1bd4eaed6b7848d09e9aaa6c7d9f31d7.png" style="width: 60px">-->
  <!--      </el-header>-->
  <!--    </el-container>-->
  <div class="whole">


    <div class="headNav">
<!--      <div>-->
        <a href="HomeV2" title="回到首页">
          <img src="../../../static/img/logo_100.png">
        </a>
<!--      </div>-->

      <h4>DCT的IT小站</h4>
      <router-link to="/HomeV2/HomePage">
        <div class="inline navDiv" style="margin-left: 60px">首页</div>
      </router-link>
      <router-link to="/HomeV2/AboutSite">
        <div class="inline navDiv">关于本站</div>
      </router-link>
      <router-link to="/HomeV2/CpuZone">
        <div class="inline navDiv">CPU专区</div>
      </router-link>
      <router-link to="/HomeV2/GpuZone">
        <div class="inline navDiv">显卡专区</div>
      </router-link>
      <router-link to="/HomeV2/EmpireEarth">
        <div class="inline navDiv">地球帝国专区</div>
      </router-link>
      <router-link to="/HomeV2/MyBlog">
        <div class="inline navDiv">个人技术博客</div>
      </router-link>
      <router-link to="/HomeV2/SmallTool">
        <div class="inline navDiv">小工具</div>
      </router-link>
      <router-link to="/HomeV2/LeaveMessage">
        <div class="inline navDiv">给站长留言</div>
      </router-link>

      <router-link to="/Login" class="r">
        <div class="inline navDiv">登录</div>
      </router-link>

      <router-link to="/Register" class="r">
        <div class="inline navDiv">注册</div>
      </router-link>
    </div>

    <div class="mainContainer centerHorizontal">
      <router-view></router-view>
    </div>
    <div class="background centerHorizontal"></div>
<!--    <el-scrollbar class="el-main-container-scrollbar">-->
<!--      <div class="mainContainer">-->

<!--      </div>-->
<!--    </el-scrollbar>-->



  </div>
</template>

<script>
    export default {
        name: "HomeV2"
    }
</script>

<style scoped>

  .mainContainer {
    width: 61.8%;
    margin-top: 60px;
    position: absolute;
    z-index: 4;
    background: #8c939d;
    padding-top: 20px;
  }

  .headNav {
    width: 100%;
    height: 60px;
    box-sizing: content-box;
    line-height: 60px;
    display: block;
    background: #2a2a2a;
    box-shadow: 0px 1px 50px #00e8bc;
    position: fixed;
    z-index: 5;
  }

  .headNav img {
    height: 40px;
    display: inline;
    float: left;
    margin-top: 10px;
    margin-left: 50px;
  }

  .headNav h4 {
    display: inline-block;
    line-height: 60px;
    height: 60px;
    float: left;
    text-align: center;
    margin-left: 20px;
  }

  .inline {
    display: inline;
  }

  .navDiv{
    /*margin: 0 15px 0 15px;*/
    padding: 0 15px;
    height: 100%;
    float: left;
    display: inline-block;
    background: transparent;
  }

  .navDiv:hover{
    background: #313131;
  }

  .whole{
    width: 100%;
    height: 100%;
  }

  .whole .background{
    position: fixed;
    width: 61.8%;
    height: 100%;
    background: #2a2a2a;
  }

  .navDiv :hover{
    background: white;
  }



</style>



// WEBPACK FOOTER //
// src/components/index/HomeV2.vue